import React, { useEffect, useRef, useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";
import { api, setCurrency, CURRENCY_SYMBOLS } from "@/lib/journal";

/** Switches the display currency for every money figure in the app. */
export const CurrencySwitcher = ({ onChanged }) => {
  const [code, setCode] = useState("USD");
  const [rates, setRates] = useState({ USD: 1 });
  const notify = useRef(onChanged);
  notify.current = onChanged;

  useEffect(() => {
    api.get("/fx").then(({ data }) => {
      setRates(data.rates);
      const c = data.display_currency || "USD";
      setCode(c);
      if (c !== "USD") {
        setCurrency(c, data.rates[c]);
        notify.current?.();
      }
    }).catch(() => {});
  }, []);

  const change = async (next) => {
    setCode(next);
    if (next !== "USD" && !rates[next]) {
      toast.info("Live FX rates are unavailable right now — showing figures in USD");
    }
    setCurrency(next, rates[next]);
    notify.current?.();
    try {
      await api.put("/settings", { display_currency: next });
    } catch {
      /* display already switched locally */
    }
  };

  return (
    <Select value={code} onValueChange={change}>
      <SelectTrigger data-testid="currency-select" className="h-9 w-[78px] rounded-none border-[#1F1F1F] bg-transparent px-3 font-mono text-xs text-zinc-300">
        <SelectValue />
      </SelectTrigger>
      <SelectContent className="rounded-none border-[#1F1F1F] bg-[#0A0A0A]">
        {Object.keys(CURRENCY_SYMBOLS).map((c) => (
          <SelectItem key={c} value={c} data-testid={`currency-${c}`} className="font-mono text-xs">
            {CURRENCY_SYMBOLS[c]} {c}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
